module.exports = "https://static.wmbcdn.com/uniweb/images/24818de30013174ee6ec26d62c95dd97.svg";